import {css} from 'lit'; export default css`:host{--goto-focus:var(--goto-border-color-default)}chameleon-text-field{width:100%}.inline{display:inline-flex}.pointer{cursor:pointer}.text-left{text-align:left}`;
    